import { ref, reactive } from '@vue/composition-api'

const CustomerModal = () => reactive({
  id: ref(''),
  user_id: ref(null),
  title: ref(''),
  image: ref(''),
  is_close_deal: ref(''),
  price_from: ref(''),
  price_to: ref(''),
  content: ref(''),
  province_id: ref(null),
  district_ids: ref([]),
  ward_ids: ref([]),
  ward_id: ref(null),
  street_ids: ref([]),
  formality: ref(''),
  type: ref(''),
  house_number: ref(''),
  expand_style: ref(''),
  currency: ref(''),
  type_of_payment: ref(''),
  expand_style_info: ref(''),
  input_price: ref(null),
  price: ref(null),
  priceDisplay: ref(null),
  transfer_price: ref(null),
  width: ref(null),
  length: ref(null),
  is_can_edit: ref(null),
  acreage: ref(null),
  max_area: ref(null),
  floor_number: ref(null),
  corner_number: ref(null),
  badger: ref(null),
  elevator: ref(null),
  basement: ref(null),
  is_hot: ref(null),
  has_corner: ref(null),
  show_in_web: ref(null),
  commission: ref(''),
  view: ref(null),
  status: ref(''),
  career: ref(null),
  meeting_count: ref(0),
  confirm_deal_count: ref(0),
  note: ref(''),
  host_name: ref(''),
  host_phone1: ref(''),
  host_phone2: ref(''),
  transfer_price_currency: ref(''),
  created_at: ref(''),
  updated_at: ref(''),
  terrace: ref(null),
  input_tl: ref(''),
  total_price: ref(null),
  product_type: ref(''),
  expire_contract_date: null,
  close_deal_type: ref(''),
  area_by_book: ref(null),
  source: ref(null),
  max_floor_number: ref(null),
  room_from: ref(null),
  room_to: ref(null),
  rating_stars: ref(null),
  logs: ref([]),
  document_files: ref([]),
  collection_id: ref([]),
  user_name: ref(''), // người tạo
  obj_collection: ref([]),
  is_owner: ref(true),
  is_creator: ref(true),
  is_manager: ref(false),
  options: ref(''),
  email: ref(''),
  area_description: ref(''),
  region_description: ref(''),
  budget_description: ref(''),
  more_description: ref(''),
  vehicle_description: ref(null),
  move_in_at: ref(null),
  purpose_description: ref(null),
  viewed_office: ref(null),
  over_time_description: ref(null),
  contract_time: ref(null),
  company_name: ref(''),
  current_office: ref(null),
  reception_at: ref(null),
  more_info: ref(null),
  area_from: ref(null),
  area_to: ref(null),
  min_price: ref(null),
  max_price: ref(null),
  meeting_date: ref(null),
})

export default CustomerModal
